import { match } from "react-router-dom";
import BatchOperations from "@/modules/pg/shared/batchOperations/BatchOperations";

type Props = {
    match: match<{ group_uuid?: string }>;
};

function BatchOperationsStandalone(props: Props) {
    const group_uuid = props.match.params.group_uuid || "";
    return <BatchOperations readOnly={false} showHistoryLink={true} showHeader={true} batchOpGroupUuid={group_uuid} />;
}

export default BatchOperationsStandalone;
